import { render } from "./LiveResults.vue?vue&type=template&id=4ca32654"
import script from "./LiveResults.vue?vue&type=script&lang=js"
export * from "./LiveResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__